import {
  Popup,
  Page,
  Navbar,
  NavRight,
  Link,
  BlockTitle,
  List,
  ListItem,
  Label,
  Input,
  Block,
  Row,
  Button,
} from "framework7-react";
import * as React from "react";
import { API_URL } from "src/utils/constants";
import { CLOUD_FUNCTION } from "../../utils/constants";

export default class NewExcel extends React.Component<{}> {
  public componentDidMount() {
    console.log("ROUTEE", this.$f7);
    this.$f7?.tooltip.create({
      targetEl: ".closeOrder",
      text: "Cancelar y Cerrar",
    });

    if (this.$$) {
      this.$$("#excel-form").on("formajax:success", (e: any) => {
        const xhr = e.detail.xhr; // actual XHR object
        const data = e.detail.data; // Ajax response from action file
        console.log("-e-", xhr, data);

        this.$f7?.popup.close(".excel-popup");
        this.$f7?.dialog.alert("CSV Guardado con éxito");
      });
    }

    this.$f7?.on("formAjaxComplete", (form, data, xhr) => {
      if (xhr.status !== 200) {
        return;
      }
      console.log("formAjaxComplete", form, data, xhr);
      this.$f7?.dialog.close();
    });

    this.$f7?.on("formAjaxBeforeSend", (form, data, xhr) => {
      this.$f7?.dialog.preloader("Guardando CSV");
    });

    this.$f7?.on("formAjaxError", (form, data, xhr) => {
      console.log("formAjaxError");
      this.$f7?.dialog.close();
      this.$f7?.dialog.alert("Error de conexión al servidor");
    });
  }

  public render() {
    return (
      <Popup className="excel-popup" closeByBackdropClick={false}>
        <Page>
          <Navbar title="Actualizar Base de Datos">
            <NavRight>
              <Link className="closeExcel" popupClose>
                <i className="icon icon-x" />
              </Link>
            </NavRight>
          </Navbar>
          <BlockTitle>
            Los campos marcados con ( * ) son obligatorios.
          </BlockTitle>

          <form
            id="excel-form"
            action={API_URL + CLOUD_FUNCTION + "saveCSV"}
            method="POST"
            encType="multipart/form-data"
            className="form-ajax-submit"
          >
            <List>
              <ListItem className={"bg-white"}>
                <Label>* Ingresa el archivo CSV (.csv)</Label>
                <Input
                  type="file"
                  required={true}
                  placeholder="Name"
                  name="file"
                  accept=".csv"
                />
              </ListItem>
            </List>
            <Block strong className={"bg-white"}>
              <Row tag="p">
                <Button popupClose className="col">
                  Cancelar
                </Button>

                <button className="col button button-fill fb">
                  Guardar CSV
                </button>
              </Row>
            </Block>
          </form>
        </Page>
      </Popup>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/prefabs/NewExcel.tsx